import { UserProfile } from '../../pages/my-account/interfaces/company-settings.interface';

export const EMPTY_USER_PROFILE: UserProfile = {
    FirstName: undefined,
    LastName: undefined,
    DisplayName: undefined,
    Email: undefined,
    Phone: undefined,
    UserId: undefined,
    ProfilePhotoUrl: undefined,
    UserLanguage: undefined,
    DefaultAddress: undefined,
    AccountRegionIsoCode: undefined,
    AccountBrandedOwner: undefined,
    UserDocumentId: undefined,
    OwnerOrganization: undefined,
    IsInternalEmployee: undefined,
    ZoneId: undefined,
    CenterId: undefined,
    CallCenterId: undefined,
    SubGroupId: undefined,
    GroupId: undefined,
};
